import React from 'react';
import DateRangeIcon from '@material-ui/icons/DateRange';
import GenericDetail from '../genericDetail';
import moment from 'moment';

interface IAdAdLeaveDateProps {
  endDate?: number;
  label?: string;
}

const AdLeaveDate = (props: IAdAdLeaveDateProps) => (
  <GenericDetail
    title={props.label}
    icon={DateRangeIcon}
  >
    {moment(props.endDate).format('MMM D YYYY')}
  </GenericDetail>
);

AdLeaveDate.defaultProps = {
  label: "תאריך הגעה",
  endDate: 0,
};
export default AdLeaveDate;
